import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import StorefrontIcon from '@mui/icons-material/Storefront'

interface MenuProviderListProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuProviderList = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuProviderListProps) => {
  const { formatMessage } = useIntl()

  const isDefaultPath = pathname.startsWith('/casino/provider-list')

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/casino/provider-list"
        selected={isDefaultPath}
      >
        <ListItemIcon>
          <StorefrontIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({ id: 'casino.menu.providerList' })}
        />
      </MenuItem>
    </div>
  )
}